import { SubscriptionResponse } from 'src/types';
import axios, { ENDPOINTS } from 'src/utils/axios';

export const getSubscriptionStatus = async () => {
  const response = await axios.get<SubscriptionResponse>(ENDPOINTS.app.subscription.status);

  return response.data;
};
